/* Kit page (templates/product.kit.json). Tier = variant of the kit product.
   Reads saved Kit Finder answers via window.JW to show fit, the finder note and a pre-sized JellyBox.
   Tier-specific markup uses data-tiers="sig five whole" and is shown/hidden by CSS on <html data-kit-tier>. */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const ready = fn => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  ready(() => {
    const root = $('#buybox'); if (!root || !window.JW) return;
    const cfg = JSON.parse(($('[data-kit-config]') || {}).textContent || '{}');
    const C = window.JW_CONFIG || { offers: {} };
    const money = c => JWUI.money(c / 100), money2 = d => '$' + (Math.round(d * 100) / 100).toFixed(2);
    const tierBtns = $$('.kit-tier', root);
    const T = {}; tierBtns.forEach(b => T[b.dataset.tier] = { variant: +b.dataset.variant, price: +b.dataset.price, btn: b });
    const ids = ['sig', 'five', 'whole'].filter(t => T[t]);
    const html = document.documentElement;

    // ---------- saved quiz ----------
    const saved = JW.saved(), A = saved && saved.answers;
    const rec = A ? JW.rec(A) : null;
    let savedTier = null; try { savedTier = (saved && saved.tier) || localStorage.getItem('jw.tier'); } catch (e) {}
    if (rec && !savedTier) savedTier = rec.tier;
    const refill = A ? JW.refill(A) : null;
    const boxItems = A ? JW.cartItems(A, { subscribe: true }).filter(i => i.selling_plan) : [];
    const offerBox = !!($('[data-refill]', root) && refill && refill.path === 'box' && boxItems.length);
    const box = A ? JW.boxSummary(A) : null;

    const S = { tier: html.dataset.kitTier || cfg.defaultTier || 'five', pair: false, care: false, plan: 'kit', scent: 0, ship: null, asked: false };
    const urlHasVariant = new URLSearchParams(location.search).has('variant');
    if (!urlHasVariant && savedTier && T[savedTier]) S.tier = savedTier;
    if (!T[S.tier]) S.tier = ids[0];
    const shipChecked = $('.kit-shipopt[aria-checked="true"]', root); S.ship = shipChecked ? +shipChecked.dataset.ship : 0;
    // First box is charged + shipped later, on a date from the quiz (when the kit wax runs low).
    // At checkout the customer subscribes to the $0 "JellyBox Refill Subscription"; a Zapier step then swaps it
    // for the real box (line property _box) with its first charge on _first_charge. See project notes.
    const LATER = Object.assign({ enabled: false, handle: 'jellybox-refill-subscription', deliveryDays: 7, leadDays: 7, minDays: 14, maxDays: 84 }, cfg.later || {});
    let laterItem = null; // { id, plan } of the $0 subscription product
    // 28 Oct (Hannah): first box is charged at checkout and ships with the kit. "Ship later" is parked (LATER.enabled = false), so the ship question is hidden.
    if (!LATER.enabled) { S.ship = 0; const sq = $('.kit-ship', root); if (sq) sq.hidden = true; }
    if (offerBox && LATER.enabled) fetch(`/products/${LATER.handle}.js`).then(r => r.ok ? r.json() : null).then(p => {
      const v = p && p.variants && p.variants.find(x => x.available) , g = p && (p.selling_plan_groups || [])[0], sp = g && g.selling_plans[0];
      if (v && sp) { laterItem = { id: v.id, plan: sp.id }; render(); }
    }).catch(() => {});
    function firstShipDate() {
      const rs = JW.rows(A), weekly = rs.reduce((t, r) => t + r.perSession / r.weeks, 0);
      const n = JW.need(A), per = n.signature + n.creamy + n.ultra;
      const k = JW.plan(n, S.tier === 'sig' && S.pair ? { creamy: 100, ultra: 100 } : null).kits[S.tier];
      const weeks = weekly > 0 && k ? k.sessions * per / weekly : 6; // how long the kit wax lasts at their pace
      const days = Math.min(LATER.maxDays, Math.max(LATER.minDays, Math.round(weeks * 7 + LATER.deliveryDays - LATER.leadDays)));
      const d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + days); return d;
    }
    const fmtDate = (d, year) => d.toLocaleDateString('en-US', Object.assign({ month: 'long', day: 'numeric' }, year ? { year: 'numeric' } : {}));
    const isoDate = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const later = () => !!laterItem;
    const unitCents = id => { // AutoShip price of one bag (Recharge plan price), for the Zapier swap
      for (const ps of Object.values((window.JW_CATALOG || {}).wax || {})) for (const p of ps) { const v = (p.variants || []).find(x => x.id === id); if (v) return v.plan && v.plan.price != null ? v.plan.price : Math.round(v.price * (1 - (C.offers.autoshipPct || 35) / 100)); }
      return null;
    };

    // First-box gift off (Theme settings) or sold out: hide the gift line, skip the "skip your gift?" prompt, don't add it to the bag.
    if (C.offers.giftOn === false) { cfg.giftVariant = null; $$('.kit-gift', root).forEach(g => g.style.display = 'none'); const gd = $('[data-gift-dialog]'); if (gd) gd.remove(); }

    const pairBtn = $('[data-addon="pair"]', root), careBtn = $('[data-addon="care"]', root);
    // Kit Finder picked a non-Signature formula → pre-add the Creamy + Ultra pair to the Signature Kit
    if (rec && pairBtn && rec.formulas.some(f => f !== 'signature')) { S.pair = true; S.matched = true; }

    // ---------- fit per tier ----------
    if (A) {
      tierBtns.forEach(b => {
        const t = b.dataset.tier, p = JW.plan(JW.need(A), t === 'sig' && S.pair ? { creamy: 100, ultra: 100 } : null).kits[t];
        const f = $('[data-fit]', b); if (!p || !f) return;
        f.hidden = false; f.textContent = p.full >= 1 ? `≈ ${p.full} full session${p.full > 1 ? 's' : ''} for your routine` : 'Less than 1 full session for your routine';
        f.classList.toggle('is-low', p.full < 1);
        $('[data-match]', b).hidden = t !== savedTier;
      });
      const p = JW.plan(JW.need(A));
      const note = $('[data-finder-note]', root);
      note.innerHTML = `Your routine uses about <b>${Math.ceil(p.per / 10) * 10}g</b> of wax per session. After your kit, refills run about <b>${money2(p.after)} per session</b> with JellyBox.`;
      note.hidden = false; $('[data-nofinder]', root).hidden = true;
    }

    // ---------- refill box ----------
    const refillEl = $('[data-refill]', root);
    if (offerBox) {
      refillEl.hidden = false;
      const months = C.offers.intervalMonths || 3;
      const pct = box.boxRetail ? Math.round((1 - box.boxCost / box.boxRetail) * 100) : (C.offers.autoshipPct || 35);
      $('[data-box-mo]', root).textContent = `+ ${money2(box.boxCost / months).replace(/\.00$/, '')}/mo`;
      $('[data-box-billed]', root).textContent = `Billed ${money2(box.boxCost).replace(/\.00$/, '')} every ${months} months`;
      $('[data-box-save]', root).textContent = `Save ${pct}%`;
      const areas = (A.areas || []), list = areas.length > 1 ? areas.slice(0, -1).join(', ') + ' and ' + areas[areas.length - 1] : (areas[0] || 'every area you picked');
      const nice = list.toLowerCase().replace(/^./, c => c.toUpperCase());
      $('[data-box-areas]', root).innerHTML = (cfg.boxAreasText || 'Enough wax for <b>[areas]</b>, about [sessions] sessions per box.').replace('[areas]', JWUI.esc(nice)).replace('[sessions]', box.sessRange);
      $('[data-box-lines]', root).innerHTML = box.lines.filter(l => !l.once).map(l => `<div><b>${JW.FORMULA_NAME[l.f]}</b><span>${l.g}g</span></div>`).join('');
      $('[data-box-scents]', root).hidden = !box.lines.some(l => !l.once && l.f === 'signature');
      $('[data-due-next]', root).textContent = money2(box.boxCost).replace(/\.00$/, '');
      cfg._pct = pct;
    }

    // ---------- render ----------
    const addonsCents = () => S.tier === 'sig' ? (S.pair && pairBtn ? +pairBtn.dataset.price : 0) + (S.care && careBtn ? +careBtn.dataset.price : 0) : 0;
    const boxOn = () => offerBox && S.plan === 'box';
    function render() {
      html.dataset.kitTier = S.tier;
      const t = T[S.tier];
      tierBtns.forEach(b => b.setAttribute('aria-checked', String(b.dataset.tier === S.tier)));
      const flag = $('[data-match-flag]', root); if (flag) flag.hidden = !(savedTier && savedTier === S.tier);
      if (pairBtn) pairBtn.setAttribute('aria-pressed', String(S.pair));
      if (careBtn) careBtn.setAttribute('aria-pressed', String(S.care));
      const m = $('[data-matched]', root); if (m) m.hidden = !(S.matched && S.pair && S.tier === 'sig');
      // Upgrade nudge: Signature + both add-ons vs the 5-Step price
      const up = $('[data-upgrade]', root);
      if (up) {
        const show = S.tier === 'sig' && S.pair && S.care && pairBtn && careBtn && T.five;
        up.hidden = !show;
        if (show) {
          const total = T.sig.price + +pairBtn.dataset.price + +careBtn.dataset.price, save = total - T.five.price;
          $('[data-up-save]', up).textContent = save > 0 ? money(save) : '';
          $('[data-up-math]', up).textContent = `Signature Kit ${money(T.sig.price)} + Creamy and Ultra-Jelly™ ${money(+pairBtn.dataset.price)} + JellyCare™ ${money(+careBtn.dataset.price)}, vs ${money(T.five.price)}.`;
        }
      }
      const kitCents = t.price + addonsCents();
      $('[data-kit-price]', root) && ($('[data-kit-price]', root).textContent = money(kitCents));
      $$('[data-plan]', root).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.plan === (boxOn() ? 'box' : 'kit'))));
      const pb = $('[data-planbox]', root); if (pb) pb.classList.toggle('is-on', boxOn());
      const det = $('[data-box-detail]', root); if (det) det.hidden = !boxOn();
      $$('.kit-scent', root).forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.scent === S.scent)));
      const shipOpts = $$('.kit-shipopt', root), dueLbl = $('.kit-due .jw-h4', root), nextLbl = $('.kit-due .jw-small span', root);
      if (offerBox && later()) {
        // One dated option instead of "with my kit / N weeks after". Option text comes from the theme editor; [date] is filled in here.
        const d = firstShipDate(), ds = fmtDate(d);
        shipOpts.forEach(b => {
          const now = b.dataset.ship === '0'; b.hidden = now; if (now) return;
          if (!b.dataset.tpl) {
            // Editor text with [date] wins; otherwise (old "N weeks after my kit" text) use the built-in copy.
            const t = b.lastElementChild.innerHTML;
            b.dataset.tpl = t.includes('[date]') ? t : '<b>Ships around [date]</b><span>When your kit wax starts to run low, based on your Kit Finder answers. Nothing is charged until then, and you can change the date anytime. Your free gift ships in your first box.</span>';
            const q = $('.kit-ship > .jw-h4', root); if (q && /when should/i.test(q.textContent)) q.textContent = 'Your first box';
          }
          b.lastElementChild.innerHTML = b.dataset.tpl.replace(/\[date\]/g, JWUI.esc(ds));
          b.setAttribute('aria-checked', 'true'); const rd = $('.kit-radio', b); if (rd) rd.hidden = true;
        });
        S.firstDate = d;
        if (dueLbl) dueLbl.textContent = 'Due today';
        if (nextLbl) nextLbl.textContent = `First box ${ds}, then every ${C.offers.intervalMonths || 3} months`;
      } else {
        shipOpts.forEach(b => b.setAttribute('aria-checked', String(+b.dataset.ship === S.ship)));
      }
      const due = kitCents + (boxOn() && !later() ? Math.round(box.boxCost * 100) : 0);
      $('[data-due]', root) && ($('[data-due]', root).textContent = money(due));
      $('[data-add-price]', root).textContent = money(due);
      $('[data-ship-note]', root).textContent = due / 100 >= (C.offers.freeShip || 120) ? 'Ships free' : `Free shipping over ${JWUI.money(C.offers.freeShip || 120)}`;
      // sticky
      $('[data-sticky-name]').textContent = (cfg.names || {})[S.tier] || '';
      $('[data-sticky-sub]').textContent = boxOn() ? (cfg.stickyBox || '').replace('[pct]', cfg._pct || C.offers.autoshipPct || 35) : cfg.stickyKit;
      document.dispatchEvent(new CustomEvent('jw:kit-tier', { detail: { tier: S.tier, care: S.tier === 'sig' && S.care } }));
    }

    function setTier(t) {
      if (!T[t] || T[t].btn.getAttribute('aria-disabled') === 'true') return;
      S.tier = t; if (t !== 'sig') { S.pair = S.pair; }
      try { localStorage.setItem('jw.tier', t); } catch (e) {}
      const u = new URL(location.href); u.searchParams.set('variant', T[t].variant); history.replaceState(null, '', u);
      showSlide('hero'); render();
    }
    window.JWKit = { setTier };

    tierBtns.forEach(b => b.addEventListener('click', () => setTier(b.dataset.tier)));
    root.addEventListener('keydown', e => { // radio arrow keys
      const b = e.target.closest('.kit-tier'); if (!b || !['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;
      e.preventDefault(); const i = ids.indexOf(b.dataset.tier), n = ids[(i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : ids.length - 1)) % ids.length];
      setTier(n); T[n].btn.focus();
    });
    pairBtn && pairBtn.addEventListener('click', () => { S.pair = !S.pair; S.matched = false; render(); });
    careBtn && careBtn.addEventListener('click', () => { S.care = !S.care; render(); });
    const upBtn = $('[data-upgrade-btn]', root); upBtn && upBtn.addEventListener('click', () => { S.pair = false; S.care = false; setTier('five'); });
    $$('[data-plan]', root).forEach(b => b.addEventListener('click', () => { S.plan = b.dataset.plan; render(); }));
    $$('.kit-scent', root).forEach(b => b.addEventListener('click', () => { S.scent = +b.dataset.scent; render(); }));
    $$('.kit-shipopt', root).forEach(b => b.addEventListener('click', () => { S.ship = +b.dataset.ship; render(); }));
    $$('[data-pick-tier]').forEach(b => b.addEventListener('click', () => { setTier(b.dataset.pickTier); root.scrollIntoView({ behavior: 'smooth' }); }));

    // ---------- gallery ----------
    function showSlide(key) {
      $$('[data-slide]', root).forEach(s => { if (s.dataset.slide === 'hero') s.hidden = key !== 'hero'; else s.hidden = s.dataset.slide !== String(key); });
      $$('[data-thumb]', root).forEach(t => { const on = t.dataset.thumb === String(key); t.classList.toggle('is-on', on); t.toggleAttribute('aria-current', on); });
    }
    $$('[data-thumb]', root).forEach(t => t.addEventListener('click', () => showSlide(t.dataset.thumb)));

    // ---------- add to bag ----------
    const dlg = $('[data-gift-dialog]');
    async function add(skipAsk) {
      if (!skipAsk && offerBox && !boxOn() && !S.asked && dlg && dlg.showModal) { dlg.showModal(); return; }
      const items = [{ id: T[S.tier].variant, quantity: 1 }];
      if (S.tier === 'sig' && S.pair && pairBtn) items.push({ id: +pairBtn.dataset.variant, quantity: 1 });
      if (S.tier === 'sig' && S.care && careBtn) items.push({ id: +careBtn.dataset.variant, quantity: 1 });
      if (boxOn() && later()) {
        const d = firstShipDate(), lines = JW.cartItems(A, { subscribe: true, scents: { signature: S.scent } }).filter(i => i.selling_plan);
        const cost = money2(box.boxCost).replace(/\.00$/, '');
        items.push({ id: laterItem.id, quantity: 1, selling_plan: laterItem.plan, properties: {
          'First box ships': fmtDate(d, true),
          _first_charge: isoDate(d),
          _box: JSON.stringify(lines.map(i => ({ v: i.id, q: i.quantity, p: i.selling_plan, c: unitCents(i.id) }))), // c = AutoShip price per bag, cents
          _due_later: `${cost} on ${fmtDate(d)}`,
          _jellybox: '1', _source: 'kit_page',
          ...(cfg.giftVariant ? { _gift: String(cfg.giftVariant) } : {}) // free gift ships in the first box (added by the Zapier swap), not with the kit
        } });
      } else if (boxOn()) {
        const props = { _jellybox: '1', _first_ship_weeks: String(S.ship), _source: 'kit_page' };
        if (S.ship > 0) props['First box ships'] = `${S.ship} weeks after your kit`;
        JW.cartItems(A, { subscribe: true, scents: { signature: S.scent } }).filter(i => i.selling_plan).forEach(i => items.push({ ...i, properties: { ...props } }));
        if (cfg.giftVariant) items.push({ id: cfg.giftVariant, quantity: 1, properties: { _gift: 'first_box' } });
      }
      const btn = $('[data-add]', root), label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
      try { await JWCart.add(items); } catch (e) {} finally { btn.disabled = false; btn.innerHTML = label; render(); }
    }
    $('[data-add]', root).addEventListener('click', () => add());
    if (dlg) {
      $('[data-ask-yes]', dlg).addEventListener('click', () => { dlg.close(); S.plan = 'box'; S.asked = true; render(); add(true); });
      $('[data-ask-no]', dlg).addEventListener('click', () => { dlg.close(); S.asked = true; add(true); });
      dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    }

    // ---------- sticky bar (mobile) ----------
    const sticky = $('[data-sticky]'), addWrap = $('#kit-add');
    if (sticky && addWrap && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(addWrap);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => { const y = root.getBoundingClientRect().top + scrollY - 100; scrollTo({ top: y, behavior: 'smooth' }); });
    }

    // ---------- FAQ: how long will a kit last ----------
    $$('[data-kit-last]').forEach(el => {
      if (!A) return;
      const p = JW.plan(JW.need(A)), per = Math.ceil(p.per / 10) * 10;
      $('[data-last-flag]', el).hidden = false;
      $('[data-last-text]', el).textContent = `Your routine uses about ${per}g of wax per session. ` + ids.map(id => { const x = p.kits[id]; return `${(cfg.names || {})[id]}: ${x.full >= 1 ? 'about ' + x.full + ' full session' + (x.full > 1 ? 's' : '') : 'less than 1 full session'}`; }).join('. ') + '. JellyBox sizes your refills from the same answers, so you don’t run out.';
      const cta = $('[data-last-cta]', el); cta.textContent = 'Retake the Kit Finder'; cta.classList.add('jw-btn--secondary'); cta.href += (cta.href.includes('?') ? '&' : '?') + 'retake=1';
    });

    render();
    if (!urlHasVariant && S.tier !== (html.dataset.kitTier)) render();
  });

  // ---------- contents list + hotspots ----------
  ready(() => {
    const sec = document.querySelector('[data-kit-inside]'); if (!sec) return;
    const rows = $$('.kit-row', sec), pins = $$('.kit-pin', sec);
    let open = null;
    const toggle = id => { open = open === id ? null : id; paint(); };
    function update(tier, careAdd) {
      let n = 0;
      rows.forEach(row => {
        let shown = true, qtyText = '';
        if (row.dataset.group) {
          let tot = 0, letter = 0;
          $$('.kit-item', row).forEach(it => {
            const q = JSON.parse(it.dataset.q), v = q[tier] || (careAdd && it.dataset.care === 'true' ? q.five : 0);
            it.hidden = !v; if (v) { tot += v; $('[data-qty]', it).textContent = v; $('[data-l]', it).textContent = String.fromCharCode(97 + letter++); }
          });
          shown = tot > 0;
          const unit = row.dataset.unit;
          qtyText = row.dataset.label || ('× ' + tot + (unit ? ' ' + unit + (tot > 1 ? 's' : '') : ''));
        } else {
          const q = JSON.parse(row.dataset.q)[tier] || 0; shown = q > 0; qtyText = q;
        }
        row.hidden = !shown;
        if (shown) { n++; $('[data-n]', row).textContent = n; const qe = $(':scope > .kit-row__head [data-qty]', row); if (qe) qe.textContent = qtyText; }
        row.dataset.num = shown ? n : '';
      });
      pins.forEach(pin => {
        const row = $(`[data-row="${pin.dataset.pin}"]`, sec), pos = (pin.dataset['pos' + tier[0].toUpperCase() + tier.slice(1)] || '').split(',').map(x => parseFloat(x));
        const ok = row && !row.hidden && pos.length === 2 && !pos.some(isNaN);
        pin.hidden = !ok; if (!ok) return;
        pin.style.left = pos[0] + '%'; pin.style.top = pos[1] + '%'; pin.textContent = row.dataset.num;
      });
      paint();
    }
    function paint() {
      rows.forEach(row => {
        const id = row.dataset.row, on = open === id, head = $(':scope > button.kit-row__head', row);
        if (head) head.setAttribute('aria-expanded', String(on));
        const body = $(':scope > .kit-row__items, :scope > .kit-row__detail', row); if (body) body.hidden = !on;
      });
      pins.forEach(p => { p.classList.toggle('is-on', open === p.dataset.pin); p.style.opacity = !open || open === p.dataset.pin ? '1' : '.35'; });
    }
    rows.forEach(row => { const h = $(':scope > button.kit-row__head', row); h && h.addEventListener('click', () => toggle(row.dataset.row)); });
    pins.forEach(p => p.addEventListener('click', () => { const row = $(`[data-row="${p.dataset.pin}"]`, sec); if ($(':scope > button.kit-row__head', row)) toggle(p.dataset.pin); row.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }));
    document.addEventListener('jw:kit-tier', e => update(e.detail.tier, e.detail.care));
    update(document.documentElement.dataset.kitTier || 'five', false);
  });

  // ---------- reviews by area ----------
  ready(() => {
    $$('[data-kit-reviews]').forEach(sec => {
      const cards = $$('.kit-review', sec), tabs = $$('.kit-reviews__tab', sec), more = $('[data-more]', sec), empty = $('[data-empty]', sec);
      if (!cards.length) return;
      const step = +sec.dataset.step || 6; let area = 'All', n = step;
      const fin = window.JW && JW.saved(); const fa = fin && (fin.answers.areas || []).find(a => tabs.some(t => t.dataset.area === a));
      if (fa && cards.some(c => c.dataset.area === fa)) area = fa;
      function paint() {
        const match = cards.filter(c => area === 'All' || c.dataset.area === area);
        cards.forEach(c => c.hidden = true); match.slice(0, n).forEach(c => c.hidden = false);
        more.hidden = match.length <= n; empty.hidden = match.length > 0;
        tabs.forEach(t => t.setAttribute('aria-selected', String(t.dataset.area === area)));
      }
      tabs.forEach(t => t.addEventListener('click', () => { area = t.dataset.area; n = step; paint(); }));
      more.addEventListener('click', () => { n += step; paint(); });
      paint();
    });
  });

  // ---------- video rail ----------
  ready(() => {
    $$('[data-kit-videos]').forEach(sec => {
      const rail = $('[data-rail]', sec);
      $$('.kit-arrow', sec).forEach(b => b.addEventListener('click', () => { const w = rail.firstElementChild ? rail.firstElementChild.offsetWidth + 16 : 280; rail.scrollBy({ left: +b.dataset.dir * w, behavior: 'smooth' }); }));
      $$('[data-play]', sec).forEach(b => {
        const v = b.parentElement.querySelector('video'), f = b.parentElement;
        const stop = () => { f.classList.remove('is-playing'); v.controls = false; };
        b.addEventListener('click', () => { $$('video', sec).forEach(x => { if (x !== v) { x.pause(); x.parentElement.classList.remove('is-playing'); } }); v.muted = false; v.play().then(() => { f.classList.add('is-playing'); v.controls = true; }).catch(stop); });
        v.addEventListener('ended', stop); v.addEventListener('error', () => { stop(); b.hidden = true; }); v.addEventListener('pause', () => f.classList.remove('is-playing'));
      });
    });
  });

  // ---------- habit comparison (mobile picker) ----------
  ready(() => {
    $$('[data-kit-compare]').forEach(sec => {
      const table = $('table', sec), btns = $$('[data-col]', sec);
      btns.forEach(b => b.addEventListener('click', () => { table.dataset.show = b.dataset.col; btns.forEach(x => x.setAttribute('aria-selected', String(x === b))); }));
    });
  });
})();
